module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "o-content ie",
    attrs: {
      "id": "app"
    }
  }, [_c('div', {
    staticClass: "flex-state-buttons"
  }, [_c('div', {
    staticClass: "u-d-flex"
  }, [_c('h1', {
    staticClass: "u-margin-top-10"
  }, [_vm._v("\n                Market Analysis\n            ")])])]), _vm._v(" "), _c('p', {
    staticClass: "p-executive-dashboard__summary u-margin-bottom-20"
  }, [_vm._v("\n        The Market Analysis Dashboard will be ready soon..."), _c('br'), _c('br')])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-c18655e8!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/market-analysis/MarketAnalysis.vue
// module id = 1802
// module chunks = 0